import { hotList } from '@/mocks/campusData';
import { catOf } from './common';

const steps = [
  {
    n: '01',
    title: '先辨真假',
    text: '把“有人这么说”和“事情确凿”分开。看是否有官方来源、原始文件或完整上下文，避免被单张截图牵着走。',
  },
  {
    n: '02',
    title: '再追完整',
    text: '一个瓜有爆料、发酵、辟谣、反转、结局五个阶段。只追开头最容易误判，我们坚持把后续进展一路补全。',
  },
  {
    n: '03',
    title: '终等定论',
    text: '不抢先手、不站队。让官方记录与公开说明说话，等尘埃落定再回头看，打不打脸一目了然。',
  },
];

export default function Review() {
  return (
    <section id="review" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <div className="md:col-span-7">
          <p className="mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-red-600">
            <span className="inline-block h-px w-6 bg-red-500" />
            求真复盘
          </p>
          <h2 className="font-editorial text-2xl font-black leading-snug text-stone-900 md:text-3xl">
            辟谣不是打脸，是给事实一个机会
          </h2>
          <blockquote className="mt-5 border-l-4 border-red-500 bg-red-600/5 py-3 pl-4 text-sm font-medium italic leading-relaxed text-stone-700 md:text-base">
            “传播最快的是情绪，最慢的才是真相。我们做的，就是把慢下来的那部分，认真讲完。”
          </blockquote>
          <p className="mt-5 text-sm leading-relaxed text-stone-600 md:text-[15px]">
            反转社的每一篇内容，都遵守同一套求证逻辑。我们不靠“惊掉下巴”的标题博眼球，
            而是把信息源摊开、把时间线捋顺，让每个人都能顺着完整的证据链，自己得出该有的结论。
          </p>

          <div className="mt-7 space-y-4">
            {steps.map((s) => (
              <div key={s.n} className="flex gap-4 rounded-lg border border-stone-200 bg-white p-4 md:p-5">
                <span className="font-editorial text-2xl font-black leading-none text-red-600">{s.n}</span>
                <div>
                  <h3 className="text-sm font-bold text-stone-900 md:text-base">{s.title}</h3>
                  <p className="mt-1 text-[13px] leading-relaxed text-stone-500">{s.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-5">
          <div className="rounded-xl border border-stone-200 bg-white p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-editorial text-lg font-bold text-stone-900">今日热瓜榜 TOP5</h3>
              <a href="#feed" className="text-xs font-semibold text-red-600 hover:underline">
                看全部 →
              </a>
            </div>
            <p className="mt-1 text-xs text-stone-400">按网友讨论热度实时排序</p>

            <ol className="mt-5 space-y-4">
              {hotList.map((p, i) => {
                const cat = catOf(p.categoryKey);
                return (
                  <li key={p.id} className="flex gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-editorial text-sm font-black ${
                        i === 0
                          ? 'bg-red-600 text-white'
                          : i === 1
                            ? 'bg-amber-400 text-white'
                            : i === 2
                              ? 'bg-orange-300 text-white'
                              : 'bg-stone-100 text-stone-500'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <a
                        href="#feed"
                        className="block truncate text-sm font-semibold text-stone-800 transition hover:text-red-700"
                      >
                        {p.title}
                      </a>
                      <div className="mt-1.5 flex items-center gap-2">
                        <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-stone-100">
                          <span
                            className="block h-full rounded-full bg-red-500"
                            style={{ width: `${p.heat}%` }}
                          />
                        </span>
                        <span className="text-xs text-stone-400">{p.heat}</span>
                      </div>
                      <div className="mt-1 flex items-center gap-1.5">
                        <i className={`${cat.icon} text-[11px] text-red-500`} />
                        <span className="text-[11px] text-stone-400">{cat.name} · {p.date}</span>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}